import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarService } from '../../services/sidebar.service';
import { TitleService } from '../../services/title.service';
import { Observable } from 'rxjs';
import { AuthService } from '../../../auth/services/auth.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  animations: [
    trigger('menuAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.95)' }),
        animate('100ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))
      ]),
      transition(':leave', [
        animate('75ms ease-in', style({ opacity: 0, transform: 'scale(0.95)' }))
      ])
    ])
  ]
})
export class HeaderComponent implements OnInit {
  title$: Observable<string>;
  user: any;
  isProfileMenuOpen = false;
  facebookProvider: any;
  isRecentAdsRoute = false;

  constructor(
    private sidebarService: SidebarService,
    private titleService: TitleService,
    private authService: AuthService,
    private elementRef: ElementRef,
    private router: Router
  ) {
    this.title$ = this.titleService.title$;
  }

  ngOnInit() {
    this.onUserLogin();
    this.setupRouteDetection();
  }

  setupRouteDetection() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isRecentAdsRoute = event.url.startsWith('/recent-ads');
      }
    });
  }

  getUserProfile() {
    this.authService.getUserProfile().subscribe((user: any) => {
      this.authService.currentUserSubject.next(user.data)
      this.facebookProvider = user.data.socialAccounts?.find((e: any) => e.provider === 'facebook');
      this.user = user.data;
    });
  }

  onUserLogin() {
    this.authService.currentUser$.subscribe((user: any) => {
      if(!user) {
        this.getUserProfile();
        return;
     }
      this.user = user;
      this.facebookProvider = user.socialAccounts?.find((e: any) => e.provider === 'facebook');
    });
  }

  toggleSidebar() {
    this.sidebarService.toggleSidebar();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isProfileMenuOpen = false;
    }
  }

  toggleProfileMenu() {
    this.isProfileMenuOpen = !this.isProfileMenuOpen;
  }

  logout() {
    // Clear local storage
    this.authService.logout().subscribe();
    localStorage.clear();
    
    // Clear cookies
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    
    // Navigate to login page with full reload
    window.location.href = '/auth/login';
  }
} 